import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import DrawerHeader from "Component/Headers/drawerHeader";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckActionPermission } from "Actions/commonAction";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../../../../Actions/SaveProgressAction";
import emptylist from "../../../../../../Assets/Svg/illustration-payroll-component.svg";
import DefaultComp from "../../../../../../Component/DefaultComp/Defaultstatecomp";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import SearchSq from "../../../../../../Component/Material-ui/SearchSq";
import Payrollwidget from "../../../../../../Component/Payrollwidget";
import { ErrorMessages } from "../../../../../../Constants";
import ChooseStatutory from "./ChooseStatutory";
import DrawerComponent from "./DrawerComponent";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
  drawerPaperFullWidth: {
    width: "100%",
  },
});

class SalaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opendrawer: false,
      allsalarycomponents: [],
      selectedsalarycomponent: null,
      allmastercomponents: [],
      datareceived: false,
    };
    this.setOpenDrawer = this.setOpenDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.getallsalarycomponents = this.getallsalarycomponents.bind(this);
    this.getallmastercomponents = this.getallmastercomponents.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("salarycomponent");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getallsalarycomponents();
        this.getallmastercomponents();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getallsalarycomponents() {
    instance
      .post("payroll/getallsalarycomponent", {})
      .then((res) => {
        this.setState({
          allsalarycomponents: get(res, "data.result", []),
          datareceived: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getallmastercomponents() {
    instance
      .post(`payroll/getallmastercomponent`, {
        isstatutory: false,
        govstatutorytypeid: null,
      })
      .then((res) => {
        this.setState({
          allmastercomponents: get(res, "data.result", []),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setOpenDrawer(flag) {
    this.setState({ opendrawer: flag });
  }

  closeDrawer() {
    this.setState({ opendrawer: false, drawerType: "", editname: false });
  }

  onedit = (x) => {
    console.log("x: ", x);
    this.setState({
      opendrawer: true,
      selectedsalarycomponent: x,
      drawerType: "",
    });
  };

  oneditname = (x) => {
    console.log("x: ", x);
    this.setState({
      opendrawer: true,
      editname: true,
      selectedsalarycomponent: x,
      drawerType: "",
    });
  };

  deleteComponent = (x) => {
    this.props.closeSnackbar();
    instance
      .delete("payroll/deletesalarycomponent", {
        data: { salarycomponentid: x.displayvalue },
      })
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0120, { variant: "success" });
        this.getallsalarycomponents();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  ondelete = (x) => {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.deleteComponent(x)}
        >
          Delete
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          Dismiss
        </Button>,
      ],
    });
  };

  render() {
    const {
      opendrawer,
      selectedsalarycomponent,
      datareceived,
      allsalarycomponents,
      allmastercomponents,
      Searchtext = "",
      drawerType = "",
      editname = false,
    } = this.state;
    const { classes } = this.props;

    return (
      datareceived && (
        <IntlProvider locale="en" messages={""}>
          <div className="content-outer-wrapper">
            <Helmet>
              <title>{headersList.Config.Component.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div>
                <Drawer
                  anchor="right"
                  open={opendrawer}
                  onClose={this.closeDrawer}
                  classes={{
                    paper: classNames(
                      drawerType == "chooseStatutory"
                        ? classes.drawerPaperFullWidth
                        : classes.drawerPaper,
                    ),
                  }}
                >
                  <div
                    className="padding15 thin-scroll"
                    style={{ overflowY: "auto" }}
                  >
                    {opendrawer && (
                      <div>
                        {drawerType == "chooseStatutory" ? (
                          <ChooseStatutory
                            closeDrawer={this.closeDrawer}
                            getallsalarycomponents={this.getallsalarycomponents}
                            getallmastercomponents={this.getallmastercomponents}
                          />
                        ) : (
                          <DrawerComponent
                            closeDrawer={this.closeDrawer}
                            editname={editname}
                            selectedsalarycomponent={selectedsalarycomponent}
                            allmastercomponents={allmastercomponents}
                            getallsalarycomponents={this.getallsalarycomponents}
                            enqueueSnackbar={this.props.enqueueSnackbar}
                            {...this.props}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Drawer>
                <div>
                  <Grid container>
                    <Grid item xs={12} md={2} sm={12}>
                      <PageHeader header="Salary components" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={10}
                      sm={12}
                      style={{ justifyContent: "flex-end", display: "flex" }}
                    >
                      {allsalarycomponents && allsalarycomponents.length != 0 && (
                        <div>
                          <SearchSq
                            placeholder="Search components"
                            onChange={(e) =>
                              this.setState({
                                Searchtext: e.target.value || "",
                              })
                            }
                          />
                        </div>
                      )}
                      {this.state.permissions &&
                        this.state.permissions.editable && (
                          <div className="margin-left-8">
                            <Button
                              className="btn btn-secondary-md-blue"
                              variant="contained"
                              onClick={() =>
                                this.setState({
                                  opendrawer: true,
                                  drawerType: "chooseStatutory",
                                })
                              }
                            >
                              Choose Statutory component
                            </Button>

                            <Button
                              className="btn btn-primary-md-blue floatright margin-left-8"
                              variant="contained"
                              onClick={() =>
                                this.setState({
                                  opendrawer: true,
                                  drawerType: "",
                                  selectedsalarycomponent: null,
                                })
                              }
                            >
                              New Component
                            </Button>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                  {allsalarycomponents.length == 0 ? (
                    <div className="horizontal-middle height70vh position-rel">
                      <DefaultComp
                        heading="Create your first salary component"
                        // subheading="You can only view your expense logs after a policy has been assigned."
                        imageSrc={emptylist}
                      />
                    </div>
                  ) : (
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        sm={12}
                        style={{ display: "grid" }}
                      >
                        <div
                          className="salary-component-wrapper thin-scroll1"
                          style={{ overflowX: "auto" }}
                        >
                          {allsalarycomponents
                            .filter(
                              (x) =>
                                !Searchtext ||
                                (Searchtext &&
                                  x.displayname
                                    .toLowerCase()
                                    .search(Searchtext.toLowerCase()) !== -1),
                            )
                            .map((x) => (
                              <Payrollwidget
                                data={x}
                                onedit={this.onedit}
                                oneditname={this.oneditname}
                                ondelete={this.ondelete}
                                permissions={this.state.permissions}
                              />
                            ))}
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </div>
              </div>
            )}
          </div>
        </IntlProvider>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      removeSaveProgress,
      setSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(SalaryComponent)));
